module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/babel-runtime/core-js/is-iterable.js
 ** module id = 580
 ** module chunks = 0
 **/